import $ from "jquery";

let hideContentPopup = parseInt(sessionStorage.getItem("hide-content-popup"));
if($('#content-popup').length > 0) {
    if(hideContentPopup !== 1 || $('body').hasClass('frontpage')) {
        $.magnificPopup.open({
            items: {
                src: '#content-popup'
            },
            fixedContentPos: true,
            type: 'inline',
        });
        sessionStorage.setItem("hide-content-popup", "1");
    }
}
